import type { CSSProperties } from "react";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

const ALLOWED_SIZING_KEYS = [
  "width",
  "height",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
] as const;

export const parseSizing = ({
  sizing,
  defaultSizing = {},
}: {
  sizing?: StyleValue;
  defaultSizing?: Record<string, string>;
}): CSSProperties => {
  if (
    sizing?.type !== "sizing" ||
    typeof sizing.value !== "object" ||
    sizing.value === null
  ) {
    return {};
  }

  const current = sizing.value as Record<string, string>;

  return ALLOWED_SIZING_KEYS.reduce<CSSProperties>((acc, key) => {
    const val = current[key];
    const defaultVal = defaultSizing[key];

    if (val !== undefined && val !== null && val !== defaultVal) {
      acc[key] = val;
    }
    return acc;
  }, {});
};
